import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';

export type PaperProps = StandardProps;

export const Paper = React.forwardRef<HTMLDivElement, PaperProps>(({children, className, ...restProps}, ref) => {
  return (
    <div ref={ref} className={cn('paper', className)} {...restProps}>
      {children}
    </div>
  );
});

export default Paper;
